module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/logo-aoj-en-257af1913548db1b1a4bbba3a0dadcf7.svg";